<div class="my-4 row mx-0">
        <div class="col-lg-6 ps-md-2 px-0">
            <h5 class="text-start text-primary fw-bold ps-0 ms-0">Client Signature</h5>
        </div>
        </div>
        <div class="row mx-0">
            <div class="row mx-0 my-3" >
		<div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
			<nri-app-img-upld [imageName]="'signature'" [docTypeID]="foType" (getdocTypeID)="getID($event)"
				(imageURL)="imageURL($event)" (docTypeError)="typeError($event)" #foAdrimg></nri-app-img-upld>
			<div class="text-danger small mb-4" *ngIf="docError">
				Please upload your signature
			</div>
		</div>
	</div>
        </div>
        <div class="footer d-flex align-items-end mx-0 mt-5 pt-5 row" >
		<div class="col-6 p-0">
			<button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
		</div>
		<div class="col-6 text-end p-0 pe-md-3">
			<button class="btn btn-primary px-4" (click)="stageValidate()">Next</button>
		</div>
	</div>
    <ngx-ui-loader></ngx-ui-loader>
	<app-error-modal #errorComp></app-error-modal>